import { useGlobalData } from './Global.controller'

export default function Global() {
  useGlobalData()

  return null
}
